//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { ClientLog } from './models/ClientLog';
import type { ClientLogError } from './models/ClientLogError';
import type { ClientLogFunctional } from './models/ClientLogFunctional';
import { Utilities } from './Utilities';

export class LogsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        error: (): string => {
            let clientRequestUrl = '/api/v1/logs/_error';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        info: (): string => {
            let clientRequestUrl = '/api/v1/logs/_info';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        functional: (): string => {
            let clientRequestUrl = '/api/v1/logs/_functional';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Log error
     * @param body (optional) Details of the error that occurred
     * @return No Content
     */
    async error(
        body?: ClientLogError,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.error();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Log info
     * @param body (optional) Information log to create
     * @return No Content
     */
    async info(
        body?: ClientLog,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.info();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Log functional
     * @param body (optional) Functional log to create
     * @return No Content
     */
    async functional(
        body?: ClientLogFunctional,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.functional();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }
}
